import React, {Fragment, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate, useLocation} from 'react-router-dom';
import {CircularProgress} from '@mui/material';
import {CustomDelete, EditWithIcon, MinLoader, SimpleTooltip, TagComponent} from 'components';
import {PermissionList, RolePermission, useModal, FindSuccessItem, FindLoad, Images, tagEnums} from 'utils';
import {invoiceActions, invoicePaymentActions, httpRequestsOnSuccessActions} from 'store';
import {AddTransactionModal} from '../../../../pages/billing/invoices/core';
import {invoiceStatusEnums} from '../../../../pages/billing/invoices/constants';

const SUBMIT_TYPE = 'SUBMIT_INVOICES';
const DELETE_TYPE = 'DELETE_INVOICE';
const PAY_IN_FULL_TYPE = 'PAY_IN_FULL_PAYMENT_INVOICE';

export const InvoiceDetailHeader = ({}) => {
    const invoiceById = useSelector((state) => state.invoice.invoiceById);
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const dispatch = useDispatch();
    const {open, close} = useModal();
    const submitSuccess = FindSuccessItem(SUBMIT_TYPE);
    const paySuccess = FindSuccessItem(PAY_IN_FULL_TYPE);
    const submitLoading = FindLoad(SUBMIT_TYPE);
    const payLoading = FindLoad(PAY_IN_FULL_TYPE);

    useEffect(() => {
        if (submitSuccess) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(SUBMIT_TYPE));
            dispatch(invoiceActions.getInvoiceById(invoiceById?.id));
        }
    }, [submitSuccess]);

    useEffect(() => {
        if (paySuccess) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(PAY_IN_FULL_TYPE));
            dispatch(invoiceActions.getInvoiceById(invoiceById?.id));
        }
    }, [paySuccess]);

    const handleSubmit = () => {
        dispatch(invoiceActions.submitInvoices([invoiceById?.id]));
    };

    const handleDelete = () => {
        open(
            <CustomDelete
                info="Delete This Invoice?"
                text="Are you sure you want to delete this invoice? Bills will be moved back to Invoiceable Appts."
                handleDel={() => dispatch(invoiceActions.deleteInvoice(invoiceById?.id))}
                actionType={DELETE_TYPE}
                afterSuccess={() => {
                    close();
                    navigate(`/invoices`, {state: {tabType: info?.tabType}});
                }}
                innerText="Delete"
            />
        );
    };

    const handlePayInFull = () => {
        dispatch(invoicePaymentActions.payInFullInvoice(invoiceById?.id, {}));
    };

    const handleAddTxn = () => {
        open(
            <AddTransactionModal
                invoice={invoiceById}
                afterSuccess={() => {
                    close();
                    dispatch(invoiceActions.getInvoiceById(invoiceById?.id));
                }}
            />
        );
    };

    return (
        <Fragment>
            <div className="tabs-wrapper">
                <div className="space-between-flex-start">
                    <div>
                        <div className="detail-page-title-box">
                            <p>Invoice ID: </p>
                            <span> {invoiceById?.displayId}</span>
                        </div>
                        <div style={{marginTop: 12}}>
                            <TagComponent
                                userInfo={invoiceById}
                                module={tagEnums.INVOICE}
                                singleView
                                doNotCropTags
                                maxTags={null}
                                notSetText={'No tags added'}
                            />
                        </div>
                    </div>
                    <div className="flex-align-start" style={{gap: 16}}>
                        {(!info?.activeTab || info?.activeTab === 'Details') && (
                            <div className="flex-align-center" style={{gap: 16}}>
                                {RolePermission([PermissionList.INVOICE_CREATE?.code]) &&
                                    invoiceById?.status === invoiceStatusEnums.PENDING && (
                                        <button
                                            style={{width: 135}}
                                            className="detail-page-submit-btn"
                                            onClick={handleSubmit}
                                            disabled={!!submitLoading}>
                                            {submitLoading?.length ? (
                                                <MinLoader margin={'0'} color={'white'} position="relative"/>
                                            ) : (
                                                'Submit Invoice'
                                            )}
                                        </button>
                                    )}

                                {RolePermission([PermissionList.INVOICE_PMT_PAY?.code]) &&
                                    invoiceById?.status === invoiceStatusEnums.OPEN && (
                                        <button
                                            style={{width: 95}}
                                            className="detail-page-submit-btn"
                                            onClick={handlePayInFull}
                                            disabled={!!payLoading}>
                                            {payLoading?.length ? (
                                                <MinLoader margin={'0'} color={'white'} position="relative"/>
                                            ) : (
                                                'Pay in Full'
                                            )}
                                        </button>
                                    )}

                                {RolePermission([PermissionList.INVOICE_PMT_PAY?.code]) &&
                                    (invoiceById?.status === invoiceStatusEnums.PAID ||
                                        invoiceById?.status === invoiceStatusEnums.OPEN) && (
                                        <button style={{width: 'fit-content'}} className="detail-page-submit-btn"
                                                onClick={handleAddTxn}>
                                            Add Transaction
                                        </button>
                                    )}

                                {RolePermission([PermissionList.INVOICE_CREATE?.code]) &&
                                    (invoiceById?.status === invoiceStatusEnums.PENDING ||
                                        invoiceById?.status === invoiceStatusEnums.OPEN) && (
                                        <SimpleTooltip
                                            title={invoiceById?.paidAMT > 0 ?
                                                <p>Cannot delete invoice with payments</p> : <p>Delete</p>}
                                            placement="top-start"
                                        >
                                            <div>
                                                <EditWithIcon
                                                    disabled={invoiceById?.paidAMT > 0}
                                                    styles={{
                                                        opacity: invoiceById?.paidAMT > 0 ? 0.3 : 1,
                                                        cursor: invoiceById?.paidAMT > 0 ? 'not-allowed' : 'pointer',
                                                    }}
                                                    id={'delete-invoice'}
                                                    icon={Images.deleteTag}
                                                    type={'button'}
                                                    handleClick={handleDelete}
                                                />
                                            </div>
                                        </SimpleTooltip>
                                    )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Fragment>
    );
};
